import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { useSelector, useDispatch } from 'react-redux';
import { redirectUrlAction } from '../../middleware/redirectUrlAction';
import { useHistory } from 'react-router-dom';
import useStateRef from 'react-usestateref';

function MyAccountTile(props) {
    let history = useHistory();
    const[renderType, setRenderType] = useState("");
    const[isPunchout, setIsPunchout, isPunchoutRef] = useStateRef(false);
    const [screenWidth, setScreenWidth, screenWidthRef] = useStateRef("")
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const MyAccountDetails = props.data?.[0]?.ContentRuleZone?.[0]?.attributes
    const  mainImage = props.data?.[0]?.ContentRuleZone?.[0]?.menuImage
    const  altText = props.data?.[0]?.ContentRuleZone?.[0]?.attributes?.altText
    var profile = props.profile;
    const dispatch = useDispatch();

    useEffect(() => {
     
        if (profileDetails && profileDetails.userTypeCheck && Object.keys(profileDetails.userTypeCheck).length > 0 && !profileDetails.userTypeCheck.showAccount && profileDetails.userSegment['Punchout Session'] === true ) {   
            //console.log("my-account - ",document.getElementById("my-account"))
            // if(document.getElementById("my-account")) {
            //     document.getElementById("my-account").classList.remove("d-block")
            //     document.getElementById("my-account").classList.add("d-none")
            // } 
            setIsPunchout(true)
        } else {
            console.log('MyAccount tile not hidden...')
        }

        if(MyAccountDetails.renderPosition) {
            setRenderType(MyAccountDetails.renderPosition)
          }


    }, [profileDetails])


    useEffect(() => {
        setScreenWidth(screen.width);
      }, []);

    const handleAccountLogin = (event) => {
        // event.preventDefault();
        // props.handleAccountLogin(event);
        dispatch(redirectUrlAction("/account/landing"))
    }
    const handleClick = (event) => {
        // event.preventDefault();
        dispatch(redirectUrlAction("/account/landing"))
        // if (event.ctrlKey || event.metakey) {
        //     if (profile && profile.transient) {
        //         window.open("/account/login", "_blank")
        //     } else {
        //         window.open('/account/landing', "_blank")
        //     }
        // } else {
        //     if (profile && profile.transient) {
        //         history.push("/account/login")
        //     } else {
        //         history.push('/account/landing')
        //     }
        // }
    }
    const handleLogOut = (event) => {
        event.preventDefault();
        props.handleLogOut(event);
    };

    return (
        <>
            <li id={`${screenWidthRef.current > 991 ? "my-account" : "my-account-mobile"}`}  className={`text-center icon-width-popup popover__wrapper c-my-account-image ${isPunchoutRef.current ? "d-none": "d-block"} ${MyAccountDetails?.additionalCss ? MyAccountDetails.additionalCss :"" }`}>

            {renderType === "TextOnly"? <Link className='link-icon-style c-utility-nav-label' style={{ cursor: 'pointer' }} to={{pathname : `${profile?.transient ? '/account/login' : '/account/landing'}` , state: {previousUrl :'/account/landing'}}} onClick={handleClick}>
            <span className='d-block nav-text-hover'>{MyAccountDetails?.displayName ? MyAccountDetails.displayName : ""}</span>
            </Link> 
                : renderType === "IconOnly" ? <Link className='link-icon-style c-utility-nav-label' style={{ cursor: 'pointer' }} to={{pathname : `${profile?.transient ? '/account/login' : '/account/landing'}` , state: {previousUrl :'/account/landing'}}} onClick={handleClick}>
                {MyAccountDetails.menuIcon ? <i class={`${MyAccountDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
            </Link>
                : renderType === "LeftIconThenText" ? <Link className='link-icon-style c-utility-nav-label' style={{ cursor: 'pointer' }} to={{pathname : `${profile?.transient ? '/account/login' : '/account/landing'}` , state: {previousUrl :'/account/landing'}}} onClick={handleClick}>
                {MyAccountDetails.menuIcon ? <i class={`${MyAccountDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                <span className='d-block nav-text-hover'>{MyAccountDetails?.displayName ? MyAccountDetails.displayName : ""}</span>
            </Link> 
                : renderType === "LeftTextThenIcon" ? <Link className='link-icon-style c-utility-nav-label' style={{ cursor: 'pointer' }} to={{pathname : `${profile?.transient ? '/account/login' : '/account/landing'}` , state: {previousUrl :'/account/landing'}}} onClick={handleClick}>
                 <span className='d-block nav-text-hover'>{MyAccountDetails?.displayName ? MyAccountDetails.displayName : ""}</span>
                {MyAccountDetails.menuIcon ? <i class={`${MyAccountDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
            </Link> 
                : renderType === "TextAboveIcon" ? <Link className='link-icon-style c-utility-nav-label' style={{ cursor: 'pointer' }} to={{pathname : `${profile?.transient ? '/account/login' : '/account/landing'}` , state: {previousUrl :'/account/landing'}}} onClick={handleClick}>
                {MyAccountDetails.menuIcon ? <i class={`${MyAccountDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                <span className='d-block nav-text-hover'>{MyAccountDetails?.displayName ? MyAccountDetails.displayName : ""}</span>
            </Link>
                : renderType === "TextBelowIcon" ? <Link className='link-icon-style c-utility-nav-label' style={{ cursor: 'pointer' }} to={{pathname : `${profile?.transient ? '/account/login' : '/account/landing'}` , state: {previousUrl :'/account/landing'}}} onClick={handleClick}>
                 <span className='d-block nav-text-hover'>{MyAccountDetails?.displayName ? MyAccountDetails.displayName : ""}</span>
                {MyAccountDetails.menuIcon ? <i class={`${MyAccountDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
            </Link> 
                : ""}


                {/* <Link className='link-icon-style c-utility-nav-label' style={{ cursor: 'pointer' }} to={{pathname : `${profile?.transient ? '/account/login' : '/account/landing'}` , state: {previousUrl :'/account/landing'}}} onClick={handleClick}>
                    <i class="fas fa-id-card icon-profile-style"></i> 
                    <span className='d-block nav-text-hover'>{MyAccountDetails?.displayName ? MyAccountDetails.displayName : ""}</span></Link> */}
                {screenWidthRef.current > 991 ? 
                profileDetails && profileDetails.transient ?
                     <div class="popover-myaccount-content popover__content my-account-menu">
                         {/* <p class="popover__message">Login or register now to maximize your savings and access profile information, order history, tracking, shopping lists, and more. </p>
                         <div className='text-end'>
                             <Link style={{ textDecoration: "none" }} to='/account/login' onClick={handleAccountLogin} >
                                 <button className='mx-1 btn btn-sm btn-color'>Login</button>
                             </Link>
                             <Link style={{ textDecoration: "none" }} to='/account/login' onClick={handleAccountLogin} >
                                 <button className='btn btn-sm btn-color'>Create an Account</button>
                             </Link>

                         </div> */}
                     
                    <div className='col-12'>
                    <p class="popover__message">Login or register now to maximize your savings and access profile information, order history, tracking, shopping lists, and more. </p>
                         <div className='login-register'>
                             <Link style={{ textDecoration: "none" }} to='/account/login' onClick={handleAccountLogin} >
                                 <button className='mx-1 btn btn-sm btn-color'>Login</button>
                             </Link>
                             <Link style={{ textDecoration: "none" }} to='/account/login' onClick={handleAccountLogin} >
                                 <button className='btn btn-sm btn-color'>Register</button>
                             </Link>
                         </div>
                    </div>
                    <div className='my-account-arrow'></div>
                </div>
                    :
                    <div class="popover__content popover-myaccount-content my-account-menu">
                        {/* <h6 className='contactfont-clr text-start'>{MyAccountDetails?.displayName ? MyAccountDetails.displayName : ""}</h6> */}
                        {/* <p class="popover__message">Access all of your convenient online account features below.</p> */}
                        {/* <ul class="list-unstyled">
                            <li class=""><Link rel="nofollow" to="/account/profile">My Profile</Link></li>
                            {profileDetails && profileDetails.userType && profileDetails.userType == '2' &&
                                <li class=""><Link rel="nofollow" to="/account/b2i/organization-user">My Organization</Link></li>
                            }
                            <li class=""><Link rel="nofollow" to="/account/list">Shopping Lists</Link></li>
                            {profileDetails && profileDetails.userType && profileDetails.userType != '3' &&
                                <li class=""><Link rel="nofollow" to="/account/order">Order History</Link></li>
                            }
                        </ul>
                        <div className='justify-content-between align-items-center d-flex'>
                            <Link className='c-my-account-a' onClick={handleLogOut} style={{ textDecoration: "none", cursor: 'pointer' }}>
                                Log Out
                            </Link>
                            <Link to={profileDetails && profileDetails.transient ? "/account/login"
                                : profileDetails && profileDetails.userType == '4' ? '/account/login' :
                                    '/account/landing'} style={{ textDecoration: "none" }}>
                                <button className='btn btn-sm btn-color'>My Account</button>
                            </Link>
                        </div> */}

                    <div className='col-12'>
                        <h5>Account Information</h5>
                        <div className=''>
                            <ul className=''>
                                <li className=''><Link to={profileDetails && profileDetails.transient ? "/account/login"
                                    : profileDetails && profileDetails.userType == '4' ? '/account/login' :
                                        '/account/landing'} style={{ textDecoration: "none" }}>My Account</Link>
                                </li>
                                <li className=''><Link to="/account/profile">Profile</Link></li>
                                {profileDetails && profileDetails.userType && profileDetails.userType == '2' &&
                                <li className=''><Link rel="nofollow" to="/account/b2i/organization-user">My Organization</Link></li>}
                                {profileDetails && profileDetails.userType && profileDetails.userType != '3' &&
                                <li className=''><Link to="/account/order">Order History</Link></li>}
                                <li className=''><Link to="/account/list">Shopping Lists</Link></li>
                            </ul>
                        </div>
                        <div className='logout d-flex'>
                            <Link className='c-my-account-a' onClick={handleLogOut} style={{ textDecoration: "none", cursor: 'pointer' }}>
                                Log Out
                            </Link>
                        </div>
                    </div>
                    <div className='my-account-arrow'></div>
                    </div>
                :""}
            </li>
        </>
    )
}

export default MyAccountTile

